
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputCheckBox from '../../commons/form/InputCheckBox'
import InputNumber from '../../commons/form/InputNumber'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { documentTypeView } from '../../../constants/backendIds'
import { getComboTranslatedFromEnum, handleKeyDown } from '../../../util/utils'
import { getObjectWithLocales } from '../../../util/masters/masters'

class DocumentTypeMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      const documentTypeMetadataWithLocales = getObjectWithLocales(this.props.documentType, this.props.documentType?.documentTypeLocales ?? [], this.props.languageList)
      this.props.initialize(documentTypeMetadataWithLocales)
    }
  }

  submitDocument (values) {
    let languages = []
    Object.keys(values).map(item => {
      if (!!values[item] && typeof values[item] === 'object') {
        languages.push(values[item])
      }
    })
    const documentType = {
      id: values.id,
      documentTypeEntityId: values.documentTypeEntityId,
      documentTypeView: values.documentTypeView,
      hasMultipleDocs: values.hasMultipleDocs,
      validationRequired: values.validationRequired,
      solpheoContainerId: values.solpheoContainerId,
      isExpirationType: values.isExpirationType,
      functionToExpire: values.functionToExpire,
      hasDescription: values.hasDescription,
      documentTypeLocales: languages
    }

    this.props.actions.submitDocumentType(documentType)
  }

  render () {
    const {
      t, handleSubmit, languageList,
      showModal, documentTypeId,
      combos: { documentTypeEntities }
    } = this.props
    const tKey = 'MASTERS.DOCUMENT_TYPE_MASTERS.MODAL.'
    let viewTypes = getComboTranslatedFromEnum(t, tKey, documentTypeView)
    return (
      <Modal id="documentTypeMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeDocumentTypeMasterModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeDocumentTypeMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form auto z-2">
              {documentTypeId &&
                <Field
                  component={InputText}
                  colWidth={0} // 25, 33, 50, 75, 100 default=25
                  name="id"
                  controlLabel={t(`${tKey}ID`)}
                  placeholder={t(`${tKey}ID`)}
                  disabled={true}
                />
              }
              <Field
                component={InputSelect}
                colWidth={0} // 25, 33, 50, 75, 100 default=25
                name="documentTypeEntityId"
                controlLabel={t(`${tKey}ENTITY_TYPE`)}
                placeholder={t(`${tKey}ENTITY_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={documentTypeEntities}
              />
            </div>
            <div className="search-form z-1">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="documentTypeView"
                controlLabel={t(`${tKey}TYPE_VIEW`)}
                placeholder={t(`${tKey}TYPE_VIEW`)}
                valueKey="id"
                labelKey="value"
                options={viewTypes}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="functionToExpire"
                controlLabel={t(`${tKey}EXPIRE_FUNCTION`)}
                placeholder={t(`${tKey}EXPIRE_FUNCTION`)}
                required={[true]}
                maxLength={50}
              />
              <Field
                component={InputNumber}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="solpheoContainerId"
                controlLabel={t(`${tKey}STORAGE_CONTAINER`)}
                placeholder={t(`${tKey}STORAGE_CONTAINER`)}
                maxLength={9}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="validationRequired"
                placeholder={t(`${tKey}REQUIRE_VALIDATION`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="hasMultipleDocs"
                placeholder={t(`${tKey}MULTIPLE_DOCS`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="isExpirationType"
                placeholder={t(`${tKey}EXPIRES`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="hasDescription"
                placeholder={t(`${tKey}HAS_DESCRIPTION`)}
              />
            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editDocumentType',
  validate: (values, props) => {
    let error = {}
    if (values) {
      const tKey = 'MASTERS.DOCUMENT_TYPE_MASTERS.VALIDATION.'
      if (!values.documentTypeEntityId) {
        error.documentTypeEntityId = props.t(`${tKey}ENTITY_TYPE`)
      }
      if (!values.documentTypeView) {
        error.documentTypeView = props.t(`${tKey}TIPE_VIEW`)
      }
      if (!values.solpheoContainerId) {
        error.solpheoContainerId = props.t(`${tKey}SOLPHEO_CONTAINER_ID`)
      }
      props.languageList && props.languageList.forEach((element) => {
        let valueLangName = values['lang' + element.languageId]?.name
        let valueLangDesc = values['lang' + element.languageId]?.description
        let errorLang = {
          name: null,
          description: null
        }
        if (!valueLangName) {
          errorLang.name = props.t(`${tKey}NAME`)
        } else if (valueLangName.length > 50) {
          errorLang.name = props.t(`${tKey}NAME_LENGTH`)
        }
        if (!valueLangDesc) {
          errorLang.description = props.t(`${tKey}DESCRIPTION`)
        } else if (valueLangDesc.length > 50) {
          errorLang.description = props.t(`${tKey}DESCRIPTION_LENGTH`)
        }
        error['lang' + element.languageId] = errorLang
      })
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(DocumentTypeMasterModal)
